import { Pagination } from "@mui/material";
import { Cross2Icon, UploadIcon } from "@radix-ui/react-icons";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { checkTagValidity } from "../../Utils/Utils";
import {
  ADD_PBO,
  CHARGER_LISTE_PBO,
  DELETE_PBO,
  UPDATE_PBO,
} from "../../Utils/constant";
import model from "../../assets/model-fichier/model_fichier.xlsx";
import { ConnectIcon } from "../../components/Icons/Connect";
import { Loader } from "../../components/Widget/Loader";
import { SubmitButton } from "../../components/Widget/SubmitButton";
import { deleteOne, store, updateOne } from "../../services/service";
import { usePBOStore } from "../../store/pboStore/listPboStore";
export const PointBranchementOptique = () => {
  const [selectItem, setSelectItem] = useState(null);
  const [fichier, setFichier] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [loadingLocalisation, setLoadingLocalisation] = useState(false);
  const [longitude, setLongitude] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const listPbo = usePBOStore();
  const [message, setMessage] = useState("");
  const [count, setCount] = useState(0);
  const handleChangeFichier = (e) => {
    console.log(e.target.files);
    const selectedFiles = e.target.files;
    const newFiles = Array.from(selectedFiles);
    setFichier((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleClick = () => {
    setLoadingLocalisation(true);
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLoadingLocalisation(false);
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setError(null);
        },
        (error) => {
          setLoadingLocalisation(false);
          setError(error.message);
        },
        {
          timeout: 10000, // Timeout after 10 seconds
          maximumAge: 0, // No cache
          enableHighAccuracy: true, // Request high accuracy
        }
      );
    } else {
      setLoadingLocalisation(false);
      setError(
        "La géolocalisation n'est pas prise en charge par ce navigateur."
      );
      console.error("Geolocation not supported by this browser.");
    }
  };

  const submit = (data) => {
    setIsSubmit(true);
    selectItem
      ? updateOne(UPDATE_PBO, selectItem?.id, data)
          .then((res) => {
            if (res.status === 200) {
              listPbo.getData("page=0&param=&size=30");
              document.getElementById("close").click();
              toast.success("Enregistrement effectuté");
              setIsSubmit(false);
              reset();
              setLongitude(null);
              setLatitude(null);
            }
          })
          .catch((err) => {
            setIsSubmit(false);
            setError(err?.response?.data?.donnee);
          })
      : store(ADD_PBO, "application/json", data)
          .then((res) => {
            if (res.status === 200) {
              listPbo.getData("page=0&param=&size=30");
              document.getElementById("close").click();
              toast.success("Enregistrement effectuté");
              setIsSubmit(false);
              reset();
              setLongitude(null);
              setLatitude(null);
            }
          })
          .catch((err) => {
            setIsSubmit(false);
            setError(err?.response?.data?.donnee);
          });
  };
  useEffect(() => {
    if (selectItem) {
      reset({
        latitude: selectItem?.latitude,
        longitude: selectItem?.longitude,
      });
    } else {
      reset();
    }
  }, [selectItem, reset]);

  useEffect(() => {
    listPbo.getData("page=0&param=&size=30");
  }, []);

  const more = (page) => {
    listPbo.getData(`page=${page - 1}&param=&size=30`);
  };

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center">
        <h3 class="font-mtn text-3xl font-bold">
          Point de branchement optique
        </h3>
      </div>

      <dialog id="modal_eligible" className="modal rounded-none">
        <div className="modal-box w-10/12 max-w-xl">
          <div className="modal-action">
            <h1 className="font-mtn mr-auto text-2xl font-bold">
              Ajout des PBO par fichier
            </h1>
            <form method="dialog">
              <button id="close_upload" className="btn btn-sm">
                <Cross2Icon />
              </button>
            </form>
          </div>
          <div>
            <label className="form-contro w-full">
              <div className="label flex flex-col justify-start items-start gap-1.5">
                <span className="label-text  font-medium text-gray-400"></span>
                <div className="w-full">
                  <div className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm ">
                    <div className="flex justify-center mb-3">
                      <UploadIcon />
                    </div>

                    <p className="text-center text-sm">
                      {fichier.length !== 0 ? "" : "Charger le fichier de PBO"}
                    </p>
                    <div className="flex justify-center">
                      <input
                        className="text-sm mx-auto file-input-bordered mb-3 file-input file-input-ghost w-full max-w-xs"
                        type="file"
                        id="fichier"
                        onChange={handleChangeFichier}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </label>
            <a
              href={model}
              download="modelPBO"
              className="btn text-white bg-black btn-sm mx-1"
            >
              Telecharger le model
            </a>
            <button
              onClick={() => {
                setIsSubmit(true);
                store(CHARGER_LISTE_PBO, "multipart/form-data", {
                  liste: fichier[0],
                })
                  .then((res) => {
                    if (res.status === 200) {
                      setIsSubmit(null);
                      listPbo.getData("page=0&param=&size=8");
                      document.getElementById("close_upload").click();
                      toast.success("Fichier chargé avec succès");
                    }
                  })
                  .catch((err) => {
                    setIsSubmit(false);
                    setMessage(err?.response?.data?.donnee);
                  });
              }}
              disabled={isSubmit ? true : fichier.length === 0 ? true : false}
              className="font-mtn bg-main btn btn-sm"
            >
              charger le fichier
            </button>
          </div>
        </div>
      </dialog>

      <div className="rounded-md px-2 py-4 mt-3">
        <div className="mt-3 lg:flex items-center gap-2">
          <input
            onChange={(e) => {
              listPbo.getData(`page=0&param=${e.target.value}&size=30`);
            }}
            type="text"
            placeholder="Rechercher element..."
            className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
          />

          <div className="ml-auto flex items-center gap-2">
            <dialog id="add_pbo" className="modal rounded-none">
              <div className="modal-box w-10/12 max-w-xl">
                <div className="modal-action">
                  <h1 className="font-mtn mr-auto text-2xl font-bold">
                    {selectItem === null
                      ? " Ajouter un PBO"
                      : "Mise à jour du PBO"}
                  </h1>
                  <form method="dialog">
                    <button id="close" className="btn btn-sm">
                      <Cross2Icon />
                    </button>
                  </form>
                </div>
                <div>
                  <p className="text-sm text-red-600">{error}</p>
                  <form
                    onSubmit={handleSubmit(submit)}
                    className="w-full  mx-auto mt-6"
                  >
                    <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                      <label className="form-control xl:w-1/2  lg:w-1/2  md:w-1/2  w-full">
                        <div className="label -mb-1">
                          <span className="label-text font-medium">
                            Nom du PBO <span className="text-red-500">*</span>
                          </span>
                        </div>
                        <input
                          {...register("nom", { required: true })}
                          type="text"
                          defaultValue={selectItem?.nom}
                          placeholder="Nom pbo"
                          className="input input-bordered w-full h-10 text-sm "
                        />
                      </label>
                      <label className="form-control xl:w-1/2  lg:w-1/2  md:w-1/2  w-full">
                        <div className="label -mb-1">
                          <span className="label-text font-medium">
                            Nombre de coupleurs{" "}
                            <span className="text-red-500">*</span>
                          </span>
                        </div>
                        <input
                          {...register("nombreCoupleur", { required: true })}
                          type="number"
                          min={0}
                          defaultValue={selectItem?.listCoupleurs?.length}
                          placeholder="Nombre de coupleur"
                          className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none app input input-bordered w-full h-10 text-sm "
                        />
                      </label>
                    </div>

                    <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                      <label className="form-control w-full">
                        <div className="label -mb-1">
                          <span className="label-text font-medium">
                            Latitude <span className="text-red-500">*</span>
                          </span>
                        </div>
                        <input
                          {...register("latitude", { required: true })}
                          type="text"
                          defaultValue={latitude}
                          onChange={(e) => setLatitude(e.target.value)}
                          placeholder="Latitude "
                          className="input input-bordered w-full h-10 text-sm "
                        />
                      </label>
                    </div>

                    <div className="">
                      <label className="form-control w-full">
                        <div className="label -mb-1">
                          <span className="label-text font-medium">
                            Longitude <span className="text-red-500">*</span>
                          </span>
                        </div>
                        <input
                          {...register("longitude", { required: true })}
                          type="text"
                          defaultValue={longitude}
                          onChange={(e) => setLongitude(e.target.value)}
                          placeholder="Longitude"
                          className="input input-bordered w-full h-10 text-sm "
                        />
                      </label>
                    </div>
                    <span
                      onClick={handleClick}
                      className="bg-black text-white btn btn-sm my-4"
                    >
                      {latitude && longitude && !loadingLocalisation ? (
                        <div className="">
                          <h2> Obtenir à nouveau</h2>
                        </div>
                      ) : !loadingLocalisation ? (
                        <h2> Position actuelle </h2>
                      ) : (
                        <div className="flex flex-row items-center justify-center w-full">
                          <ThreeDots
                            height="20"
                            width="40"
                            radius="9"
                            color="#000"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClassName=""
                            visible={loadingLocalisation}
                          />
                        </div>
                      )}
                    </span>

                    <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                      <label className="form-control w-full">
                        <div className="label -mb-1">
                          <span className="label-text font-medium">
                            Commune{" "}
                            {selectItem === null ? (
                              <span className="text-red-500">*</span>
                            ) : null}
                          </span>
                        </div>
                        <input
                          {...register("commune", {
                            required: selectItem === null ? true : false,
                          })}
                          type="text"
                          placeholder="Commune"
                          defaultValue={selectItem?.commune}
                          className="input input-bordered w-full h-10 text-sm "
                        />
                      </label>
                    </div>

                    <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                      <label className="form-control w-full">
                        <div className="label -mb-1">
                          <span className="label-text font-medium">
                            Quartier{" "}
                            {selectItem === null ? (
                              <span className="text-red-500">*</span>
                            ) : null}
                          </span>
                        </div>
                        <input
                          {...register("quartier", {
                            required: selectItem === null ? true : false,
                          })}
                          type="text"
                          defaultValue={selectItem?.quartier}
                          placeholder="quartier"
                          className="input input-bordered w-full h-10 text-sm "
                        />
                      </label>
                    </div>
                    <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
                  </form>
                </div>
              </div>
            </dialog>
            {checkTagValidity("AJOUTER_PBO") ? (
              <button
                onClick={() => {
                  setSelectItem(null);
                  reset({
                    latitude: "",
                    longitude: "",
                  });
                  document.getElementById("add_pbo").showModal();
                }}
                className="btn btn-sm h-10 hover:bg-[#ffcb05] bg-[#ffcb05] "
              >
                Ajouter un PBO
              </button>
            ) : null}

            <button
              onClick={() => {
                document.getElementById("modal_eligible").showModal();
              }}
              className="btn btn-sm h-10 hover:bg-[#000] bg-[#000] text-white"
            >
              Charger un fichier
            </button>
          </div>
        </div>
        {checkTagValidity("LISTE_PBO") ? (
          <div className="grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-4 my-8">
            {listPbo?.data?.data?.length === 0 ? (
              <div className="col-span-full text-center text-gray-500">
                Aucune donnée
              </div>
            ) : listPbo?.data?.data?.length !== 0 && !listPbo?.loading ? (
              listPbo?.data?.data?.map((item) => (
                <div
                  key={item.id}
                  className="relative p-4 rounded-xl bg-white shadow hover:shadow-lg transition-all border border-gray-200 flex items-center gap-3 cursor-pointer"
                >
                  {/* Dropdown */}
                  <div className="absolute top-3 right-3 dropdown dropdown-end">
                    <div
                      tabIndex={0}
                      role="button"
                      className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                    >
                      <MoreHorizontal size={18} className="text-gray-600" />
                    </div>
                    <ul
                      tabIndex={0}
                      className="dropdown-content z-[1] mt-2 bg-white shadow-lg border border-gray-200 rounded-lg w-48 p-2 space-y-1"
                    >
                      <button
                        onClick={() => {
                          setSelectItem(item);
                          document.getElementById("add_pbo")?.showModal();
                        }}
                        className="w-full text-left text-sm px-3 py-2 rounded-lg hover:bg-gray-100 transition"
                      >
                        Modifier
                      </button>
                      <Link
                        to={`${item.id}/Liste-port/${encodeURIComponent(
                          item.nom
                        )}`}
                        className="block text-sm px-3 py-2 rounded-lg hover:bg-gray-100 transition"
                      >
                        Voir les brins
                      </Link>
                      {checkTagValidity("SUPPRIMER_PBO") && (
                        <button
                          onClick={() => {
                            setSelectItem(item);
                            document.getElementById("delete")?.showModal();
                          }}
                          className="w-full text-left text-sm px-3 py-2 text-red-600 hover:bg-red-50 transition"
                        >
                          Supprimer
                        </button>
                      )}
                    </ul>
                  </div>

                  {/* Icon */}
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                    <ConnectIcon />
                  </div>

                  {/* Texts */}
                  <div className="flex flex-col">
                    <p className="font-semibold text-sm truncate w-36">
                      {item.nom}
                    </p>
                    <p className="text-xs text-gray-500 truncate w-28">
                      {item.commune ? `${item.commune}, ` : ""} {item.quartier}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <Loader />
            )}

            {/* Modal de confirmation suppression */}
            <dialog id="delete" className="modal">
              <div className="modal-box max-w-md rounded-lg">
                <h3 className="font-extrabold text-xl text-red-600">
                  Attention
                </h3>
                <p className="pt-2 text-black font-medium">
                  Voulez-vous vraiment effectuer cette action ?
                </p>
                <div className="modal-action">
                  <form
                    method="dialog"
                    className="w-full flex justify-end gap-3"
                  >
                    <button className="bg-gray-100 text-gray-700 px-4 py-2 rounded-md font-semibold hover:bg-gray-200">
                      Annuler
                    </button>
                    <button
                      onClick={() => {
                        deleteOne(DELETE_PBO, selectItem.id)
                          .then(() => {
                            toast.success("Élément supprimé");
                            listPbo.getData("page=0&param=&size=8");
                          })
                          .catch(() => {
                            toast.error("Erreur lors de la suppression");
                          });
                      }}
                      className="bg-red-600 text-white px-4 py-2 rounded-md font-semibold hover:bg-red-700"
                    >
                      Supprimer
                    </button>
                  </form>
                </div>
              </div>
            </dialog>
          </div>
        ) : null}
        <div className="my-3 flex justify-end">
          <Pagination
            onChange={(event, newValue) => more(newValue)}
            onSelect={(selectedPage) => more(selectedPage)}
            count={listPbo.count}
            variant="outlined"
            color="primary"
            shape="rounded"
          />
        </div>
      </div>
    </div>
  );
};
